const getStorageKey = (userId, dashboardUuid) =>
  `wg_${userId ?? ''}_${dashboardUuid}`;

const parseLayoutsFromStorage = (key) => {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return null;

    const parsed = JSON.parse(stored);
    if (Array.isArray(parsed)) return { lg: parsed };
    if (parsed && typeof parsed === 'object' && parsed.lg) return parsed;
    return null;
  } catch {
    return null;
  }
};

const saveLayoutsToStorage = (key, layouts) => {
  try {
    localStorage.setItem(key, JSON.stringify(layouts));
  } catch (err) {
    console.warn('[useWidgetGrid] Failed to save layouts to localStorage:', err);
  }
};

export { getStorageKey, parseLayoutsFromStorage, saveLayoutsToStorage };
